<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2">
          <b>Aprobar/Rechazar Descuento</b>
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="mb-0"><b>Programa:</b> {{ datas.programa }}</p>

          <v-row v-if="descuento.monto" class="mt-1" no-gutters>
            <v-col cols="12" sm="6" class="pr-sm-2">
              <p class="mb-0"><b>Concepto:</b> {{ descuento.concepto_pago.nombre }}</p>
              <p class="mb-0"><b>Monto de descuento:</b> {{ descuento.monto }} Bs.</p>
              <p class="mb-0"><b>Prorrateo:</b> {{ descuento.prorrateadoActivo ? 'SI' : 'NO' }}</p>
              <p class="mb-0"><b>Estado:</b> {{ descuento.estado }}</p>
              <p class="mb-1"><b>Descripcion:</b> {{ descuento.descripcion }}</p>
              <p class="mb-2"><b>Estudiante:</b> {{ datas.nombres }} {{ datas.primer_apellido }}</p>

              <p class="mb-1 blue--text"><b><span class="red--text">*</span> Seleccionar Estado:</b></p>
              <v-select
                v-model="estado"
                :items="[{ text: 'Aprobado', value: 'aprobado' }, { text: 'Rechazado', value: 'rechazado' }]"
                outlined
                dense
                hide-details
              />
            </v-col>

            <v-col v-if="estado == 'rechazado'" cols="12" sm="6" class="pl-sm-2 mt-3 mt-sm-0">
              <p class="mb-1"><b>Escriba una respuesta:</b></p>
              <v-textarea
                v-model.trim="respuesta"
                outlined
                dense
                rows="4"
                placeholder="Escriba la respuesta de rechazo...."
                hide-details
              />
            </v-col>
          </v-row>

          <p class="text-center red--text mt-3 mb-0"><b>{{ msg }}</b></p>
          <v-progress-linear indeterminate v-if="loading" class="mt-2" />

          <div class="mt-3">
            <p class="mb-1 blue--text">
              <b>Para continuar escriba: <span class="red--text">{{ estado }}</span> para proceder.</b>
            </p>
            <v-text-field
              v-model="proceder_text"
              outlined
              dense
              hide-details
            />
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" outlined @click="dialog = false">
            <v-icon small left>mdi-close</v-icon>
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            outlined
            :disabled="loading || !proceder_text || proceder_text != estado"
            @click="validarCampos()"
          >
            <v-icon small left>mdi-check</v-icon>
            Responder
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { getheadersrest } from '@/components/Utils';
  export default {
    data() {
      return {
        dialog: false,
        descuento: {},
        loading: false,
        msg: '',
        estado: '',
        respuesta: '',
        proceder_text: '',
        datas: { nombres: '' },
      };
    },
    methods: {
      setdescuento(desc) {
        if(!desc.concepto_pago) desc.concepto_pago = {}
        
        this.descuento = desc;
        this.msg = '';
        this.estado = '';
        this.respuesta = '';
        this.proceder_text = '';
        this.loading = false;
        this.datas = { nombres: '' };
        this.getinscripcion(desc);
        this.dialog = true;
      },
      validarCampos() {
        if (!this.estado) { this.msg = 'Seleccione un estado.'; return; }
        if (!this.respuesta && this.estado == 'rechazado') { this.msg = 'Escriba una respuesta indicando el rechazo'; return; }
        let data = {
          estado: this.estado,
          id: this.descuento.id,
          respuesta: this.respuesta,
        };
        if (!this.respuesta) delete data.respuesta;
        this.enviarrespuesta(data);
      },
      enviarrespuesta(data) {
        this.msg = '';
        const vue = this;
        vue.loading = true;
        let myHeaders = getheadersrest();
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos/respuesta`;
        window.console.log(data);

        fetch(url, {
          headers: myHeaders,
          method: 'PUT',
          body: JSON.stringify(data),
        })
          .then((res) => {
            window.console.log('RES: ', res, res.body);
            vue.loading = false;
            if (res.status == 200) {
              setTimeout(() => { vue.dialog = false; }, 300);
              vue.$emit('onrespuesta');
            }
          })
          .catch((error) => {
            window.console.error(error);
            vue.msg = error;
            vue.loading = false;
          });
      },
      getinscripcion(desc) {
        const vue = this;
        vue.datas.nombres = desc.estudiante.nombres;
        vue.datas.primer_apellido = desc.estudiante.primer_apellido;
        vue.datas.segundo_apellido = desc.estudiante.segundo_apellido;
        vue.datas.numero_documento = desc.estudiante.numero_documento;
        vue.datas.programa = desc.programa.nombre;
      },
    },
  };
</script>
